import classNames from "classnames";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "./upgradeButton.css";

interface Props {
  whiteStyle?: boolean;
  text?: string;
  onClick?: () => any;
}

export const UpgradeButton: React.SFC<Props> = ({ whiteStyle, text, onClick }) => (
  <button className={classNames(styles.upgrade, { [styles.white]: whiteStyle })} onClick={onClick}>
    {text || intl.formatMessage("plan.upgrade")}
  </button>
);
